import React from "react";
import { makeStyles, Box, colors } from "@material-ui/core";

interface SettingsItemProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;

  children?: React.ReactNode;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },

    title: {
      color: theme.palette.text.primary,
      fontSize: 16,
      fontWeight: theme.typography.fontWeightMedium,
    },

    subTitle: {
      marginTop: 2,
      fontSize: 14,
      color: colors.grey[600],
    },
  }),
  { name: "balance-details-styles" }
);

export default function SettingsItem(props: SettingsItemProps) {
  const classes = useStyles(props);
  // Props
  const { children, title, subTitle } = props;

  return (
    <Box className={classes.root}>
      <Box component="div" className={classes.title}>
        {title}
      </Box>
      <Box component="div" className={classes.subTitle}>
        {subTitle}
      </Box>

      {children ? <Box component="div">{children}</Box> : <></>}
    </Box>
  );
}
